import axios from 'axios';

const getBaseURL = () => {
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  return isLocalhost 
    ? 'http://localhost/syra%20food%20point%20seguku/backend/api' 
    : `${window.location.origin}/backend/api`;
};

const api = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
});

export { api };
